import mvtCardSchool from '@/common/components/mvtcardschool/mvt-cardschool.vue';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtListLinks from '@/common/components/mvtlistlinks/mvt-listlinks.vue';
import mvtCollapsibleLinks from '@/common/components/mvtcollapsiblelinks/mvt-collapsiblelinks.vue';
import mvtLocalHighlight from '@/common/components/mvtlocalhighlight/mvt-localhighlight.vue';
import mvtLocalHighlightScore from '@/common/components/mvtlocalhighlightscore/mvt-localhighlightscore.vue';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import mvtPageMenu from '@/common/components/mvtpagemenu/mvt-pagemenu.vue';
import mvtSelect from '@/common/components/mvtselect/mvt-select.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';
import mapper from '@/common/store/mapper/index.js';
import cardSection from '@/market-trends/components/cardsection/card-section.vue';
import marketTrendsArticleCard from '@/market-trends/components/markettrendsarticlecard/markettrendsarticlecard.vue';
import marketTrendsBreadcrumb from '@/market-trends/components/markettrendsbreadcrumb/markettrends-breadcrumb.vue';
import marketTrendsChart from '@/market-trends/components/markettrendschart/markettrends-chart.vue';
import marketTrendsDropdown from '@/market-trends/components/markettrendsdropdown/markettrends-dropdown.vue';
import marketTrendsOverview from '@/market-trends/components/markettrendsoverview/markettrendsoverview.vue';
import marketTrendsTab from '@/market-trends/components/markettrendstab/markettrends-tab.vue';
import marketTrendsTabHeader from '@/market-trends/components/markettrendstabheader/markettrends-tabheader.vue';
import marketTrendsTabs from '@/market-trends/components/markettrendstabs/markettrends-tabs.vue';
import staticWelcomeSearch from '@/schools/components/staticwelcomesearch/static-welcome-search.vue';
import mvtSeoLink from '@/common/components/mvtseolink/mvt-seolink.vue';
import { mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
import mvtListProperty from '@/common/components/mvtlistproperty/mvt-listproperty.vue';
import mvtListingCarousel from '@/common/components/mvtlistingcarousel/mvt-listing-carousel.vue';

export default {
    name: 'pageMarketTrends',
    inject: ['$eventBus'],
    mixins: [lazyCarouselCheckMixin],
    data() {
        return {
            trendType: 0,
            showAllDemo: false,
            showMarketSnapShot: false,
            showAllSchoolDistricts: false,
            schoolTypeSelected: 'Elementary',
            selectedCity: { id: '', name: '' },
            selectedMetricForNearby: { id: 'medianlistprice', name: 'Median List Price', metric_title: 'Median List Price' },
            marketTrendTypes: [
                { id: 'all', name: 'House and Condo/Townhouse' },
                { id: 'condo', name: 'Condos/Townhome' },
                { id: 'single', name: 'House' },
            ],
            selectedMarketTrendForNearby: {
                id: 'all',
                name: 'House and Condo/Townhouse',
            },
            selectedMarketTrend: 'all',
            selectedMetricId: 'medianlistprice',
            headerDataComparable: null,
            showAllSummary: false,
            schoolCardOptions: {
                hideFooter: true,
            },
        };
    },

    components: {
        mvtPopSignin,
        mvtHeader,
        mvtLocalHighlight,
        mvtDialogCenter,
        mvtSelect,
        mvtShifter,
        marketTrendsBreadcrumb,
        marketTrendsTab,
        marketTrendsTabs,
        mvtMapStatic,
        marketTrendsChart,
        mvtCardSchool,
        marketTrendsArticleCard,
        marketTrendsDropdown,
        mvtListLinks,
        marketTrendsOverview,
        cardSection,
        staticWelcomeSearch,
        mvtPageMenu,
        marketTrendsTabHeader,
        mvtLocalHighlightScore,
        mvtSeoLink,
        mvtFooter,
        mvtLazyload,
        mvtCollapsibleLinks,
        mvtListProperty,
        mvtListingCarousel,
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
        ...mapGetters('market', ['geo']),
        title() {
            return this.isHomePage ? 'State Market Trends' : `${this.market.stateName} Market Trends`;
        },
        hasOneMonthData() {
            return this.market && this.market.snapshot && this.market.snapshot.hasOneMonthData;
        },
        marketTrendImg() {
            return this.glb.cdnUrl + 'vimages/market-trends.png';
        },
        isHomePage() {
            return this.market.pageType == 'vmarket-trends-home';
        },
        isStatePage() {
            return this.market.pageType == 'vmarket-trends-state';
        },
        market() {
            return this.glb.pageData;
        },
        carouselGeoPath() {
            if (!this.geo) {
                return '';
            }
            if (this.geo.path) {
                return String(this.geo.path).replace(/^\/|\/$/g, '');
            }
            const name = String(this.geo.geoName || '').toLowerCase().replace(/\s+/g, '-');
            const st = String(this.geo.state || '').toLowerCase();
            return name && st ? `${name}-${st}` : name || st;
        },
        lastUpdatedDate() {
            var options = { year: 'numeric', month: 'long', day: 'numeric' };
            let lastDate = '';
            if (this.market && this.market.snapshot && this.market.snapshot.today && this.market.snapshot.today.formatedDate) {
                lastDate = this.market.snapshot.today.formatedDate;
            }
            return lastDate ? `last updated on ${new Date(lastDate).toLocaleDateString('en-US', options)}` : '';
        },
        getButtonDetails() {
            let btnText = '';
            btnText = this.market && this.market.cityInfo ? `${this.market.cityInfo.displayName}, ${this.market.cityInfo.stateCode} Homes For Sale` : ' ';
            if (this.market.pageType == 'vmarket-trends-zip' && this.market && this.market.currentInfo) {
                btnText = `${this.market.currentInfo.code}, ${this.market.currentInfo.stateCode} Homes For Sale`;
            } else if (this.market.pageType == 'vmarket-trends-neighborhood' && this.market && this.market.currentInfo) {
                btnText = `${this.market.currentInfo.displayName} Homes For Sale`;
            }
            return { text: btnText, url: this.glb.appUrl + `${this.market ? this.market.homeForSaleUrl || (this.market.cityInfo && this.market.cityInfo.sitemapCityPropertyPageUrl) : ''}` };
        },
        getTrendsData() {
            let arr = [];
            for (var i = 0; i < this.market.marketTrendsSnapshot.length; i++) {
                arr.push({ text: this.market.marketTrendsSnapshot[i].title, value: i });
            }
            return arr;
        },
        getSchoolData() {
            let data = [];
            data.push({ text: 'School Districts', count: (this.market.schoolDistricts && this.market.schoolDistricts.length) || 0 });
            if (this.market.schoolChartData) {
                data.push(
                    { text: 'Elementary Schools', count: this.market.schoolChartData.elementary },
                    { text: 'Middle Schools', count: this.market.schoolChartData.middle },
                    { text: 'High Schools', count: this.market.schoolChartData.high }
                );
            }
            return data;
        },
        getSchools() {
            const schools = this.market.nearbySchools && this.market.nearbySchools.types && this.market.nearbySchools.types.filter((school) => school.type == this.schoolTypeSelected);
            return schools && schools[0].list;
        },
        getMetric() {
            return this.data.metric;
        },
        getComparedCity() {
            return {
                id: this.market.allCompares[0].id,
                name: this.market.allCompares[0].name,
            };
        },
        listingData() {
            return this.market.nearbyHomes ? this.market.nearbyHomes.listings.map((listing) => mapper.property(listing, this.glb)) : null;
        },
        getSelectedCity() {
            return this.selectedCity;
        },
        getSelectedMetricForNearby() {
            return this.selectedMetricForNearby;
        },
        getSelectedMarketTrendForNearby() {
            return this.selectedMarketTrendForNearby.id;
        },
        getSeoLinks() {
            if (!this.market.seoLinks) {
                return null;
            }
            return this.market.seoLinks.filter((item) => item.links.length > 0);
        },
        getLocalHighlightScore() {
            return this.market.localHighlightScore;
        },
        getLocalHighlight() {
            return this.market.localHighlightGeo || [];
        },
        getDemoToggleText() {
            const text = this.showAllDemo ? 'Less' : 'More';
            return `See ${text} Demographics and Neighborhood info`;
        },
        getSummaryToggleText() {
            const text = this.showMarketSnapShot ? 'Less' : 'More';
            return `See ${text} Statistics & Trends`;
        },
        getSchoolDistrictsToggleText() {
            return `See ${this.showAllSchoolDistricts ? 'Less' : 'More'}`;
        },
        showToggleLinks() {
            return this.market.pagesIncluded && this.market.pagesIncluded.length > 2;
        },
        getSchoolDistrictsLinks() {
            let schoolDistricts = this.showAllSchoolDistricts ? this.market.schoolDistricts : this.market.schoolDistricts.slice(0, 9);
            return schoolDistricts.map((link) => {
                link.nameForUrl = link.districtUrl;
                link.displayName = link.name;
                return link;
            });
        },
        getMetricForComparable() {
            let snapshot = this.market.marketTrendsSnapshot.find((snap) => snap.type == this.selectedMarketTrendForNearby.id);
            let selectedMetric = snapshot && snapshot.marketSnapShot.find((snap) => snap.id == this.selectedMetricForNearby.id);
            return (selectedMetric && { ...selectedMetric, value: selectedMetric.value.replace(/\/Sqft/, '') }) || {};
        },
        marketTrendsSnapshot() {
            return this.market.marketTrendsSnapshot.find((snap) => snap.type == this.selectedMarketTrend);
        },
        selectedMetric() {
            var that = this;
            return this.marketTrendsSnapshot && this.marketTrendsSnapshot.marketSnapShot.find((market) => market.id == that.selectedMetricId);
        },
        homePageLinks() {
            if (this.isHomePage) {
                return this.market.states.map((state) => {
                    return {
                        url: `${this.glb.appUrl}${state.stateStatisticsPageUrl}`,
                        text: `${state.displayName} Real Estate Market`,
                    };
                });
            }
            return [];
        },
        getTitle() {
            return `Market Trends in ${this.market.stateName}`;
        },
        generateCityLinks() {
            return this.market.cities.map((city) => {
                const url = `${this.glb.appUrl}${city.cityStatisticsPageUrl}`;
                const text = `${city.displayName} Market Trends ${city.listingCount ? ` <span class="f7">(${city.listingCount})</span>` : ''}`;
                return {
                    multipart: true,
                    parts: [{ url, text }]
                }
            });
        },
    },
    methods: {
        togglePageSummary() {
            this.showAllSummary = !this.showAllSummary;
        },
        updateMarketTrend(value) {
            this.selectedMarketTrend = value.id;
        },
        updateMetric(value) {
            this.selectedMetricId = value.id;
        },
        updateHeaderData(value) {
            this.headerDataComparable = { value: value, metric_title: this.selectedMetricForNearby.metric_title };
        },
        toggleSchoolType(value) {
            this.schoolTypeSelected = value;
            this.resetScroller();
        },
        resetScroller() {
            if ($(this) && this.$refs && this.$refs.shifter && $(this.$refs.shifter.$refs)) {
                let $scroller = $(this.$refs.shifter.$refs.scroller);
                $scroller.scrollLeft(0);
            }
        },
        completed(type) {
            this.$refs['lazyload' + type].ready();
        },
        geoInfoForListings(propType = 'new') {
            let displayNameForListings = '';
            let pathForListings = '';
            let geoInfoType = '';
            if (this.geo.neighborhood) {
                displayNameForListings = this.geo.neighborhood;
                pathForListings = this.geo.neighborhoodPath;
                geoInfoType = 'neighborhood';
            } else if (this.geo.zipcode) {
                displayNameForListings = this.geo.zipcode;
                pathForListings = this.geo.zipcodePath;
                geoInfoType = 'zipcode';
            } else if (this.geo.city) {
                if (propType === 'open') {
                    pathForListings = `${this.geo.city} ${this.geo.state}`;
                } else {
                    pathForListings = this.geo.cityId;
                }
                displayNameForListings = `${this.geo.city}, ${this.geo.state}`;
                geoInfoType = 'city';
            }
            return { title: displayNameForListings, path: pathForListings, geoInfoType: geoInfoType };
        },

        updateSelectedCity(value) {
            this.selectedCity = value;
        },
        updateSelectedMetric(value) {
            this.selectedMetricForNearby = value;
        },
        updatedSelectedFilter(value) {
            this.selectedMarketTrendForNearby = value;
        },
        toggleDemographics() {
            this.showAllDemo = !this.showAllDemo;
        },
        toggleMarketSnapshot() {
            this.showMarketSnapShot = !this.showMarketSnapShot;
        },
        toggleSchoolDistricts() {
            this.showAllSchoolDistricts = !this.showAllSchoolDistricts;
        },
    },

    mounted() {
        if (this.market.allCompares && this.market.allCompares.length) {
            this.selectedCity = this.market.allCompares[0];
        }

        this.$eventBus.$emit('eventbus-pageLoaded');
        this.toggleSchoolType(this.schoolTypeSelected);
        this.showMarketSnapShot = !this.showToggleLinks;
    },
};
